import { Component, Inject, HostListener, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpParams} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
@Component({
  selector: 'app-update-form',
  templateUrl: './update-form.component.html',
  styleUrls: ['./update-form.component.scss']
})
export class UpdateFormComponent implements OnInit {
  testCaseUpdateForm: UntypedFormGroup;
  submitted=false;
  titleForUpdate: any;
  dataLabelsForUpdate: any;
  testCaseIdForUpdate: any;
  commentForUpdate: any;
  testCassedata: any;
  url: string;
  parentId: any;
  projectId: any;
  Id: any;
  executionIteration: any;
  regexStr = '^[a-zA-Z0-9_{}[]() ]+$'
  tagArray = ["IMPORTANT","VERY_IMPORTANT","GOOD_TO_HAVE"]
  adoIntIdForUpdate: any;
  ADOCheck = localStorage.getItem('isADOEnabled') == 'true' ? true : false;
  currentTestCase: any;
  hasChange: boolean=false;
  initialFormValue: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data,
  private formBuilder: UntypedFormBuilder,
  private http: HttpClient,
  private toastrService: ToastrService,
  public dialogRef: MatDialogRef< UpdateFormComponent>) { 
    this.url=environment.baseUrl;
    
    this.titleForUpdate = data.message[0].title;
    if(this.titleForUpdate == 'Test Case1'){
      this.titleForUpdate == 'Task List 1'
    }
    else{
      this.titleForUpdate = data.message[0].title;
    }
    this.currentTestCase = JSON.parse(JSON.stringify(this.titleForUpdate))
    this.testCaseIdForUpdate = data.message[0].testCaseId;
    if(data.message[0].testCaseId){
      this.testCaseIdForUpdate = data.message[0].testCaseId;
    }
    else{
      this.testCaseIdForUpdate = '';
    }
    this.dataLabelsForUpdate = data.message[0].dataLabels;
    if(data.message[0].dataLabels){
      this.dataLabelsForUpdate = data.message[0].dataLabels;
    }
    else{
      this.dataLabelsForUpdate = '';
    }
    this.adoIntIdForUpdate = data.message[0].adoIntId;
    this.commentForUpdate = data.message[0].comment;
    if(data.message[0].comment){
      this.commentForUpdate = data.message[0].comment;
    }
    else{
      this.commentForUpdate = '';
    }
    this.parentId = data.message[0].parentTestDataId;
    this.projectId = data.message[0].projectId;
    this.Id = data.message[0].id;
    if(data.message[0].execuationIteration){
      this.executionIteration = data.message[0].execuationIteration;
    }
    else{
      this.executionIteration = '';
    }
    if(data.message[0].adoIntId){
      this.adoIntIdForUpdate = data.message[0].adoIntId;
      
    }
    else{
      this.adoIntIdForUpdate = '';
    }
    // console.log(
    //   this.titleForUpdate,
    //   this.testCaseIdForUpdate,
    //   this.dataLabelsForUpdate,
    //   this.commentForUpdate,
    //   this.executionIteration
    // )

    this.initForm();

  }

 initForm()
 {
  this.testCaseUpdateForm = this.formBuilder.group({
    title:[this.titleForUpdate, [
      Validators.required,
      Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)
  ]],
    testCaseId:[this.testCaseIdForUpdate],
    dataLabels:[this.dataLabelsForUpdate],
    comment:[this.commentForUpdate],
    executionIteration:[this.executionIteration, [
      Validators.required,
      Validators.min(1)
  ]]
  })

  let addNewField = this.ADOCheck ? this.testCaseUpdateForm.addControl('adoIntId', this.formBuilder.control(this.adoIntIdForUpdate)) : this.testCaseUpdateForm.removeControl('adoIntId');
  this.initialFormValue = { ...this.testCaseUpdateForm.value };
  this.testCaseUpdateForm.valueChanges.subscribe(() => {
    this.checkFormChange();
  });
 }

ngOnInit() {
  
}
checkFormChange(): void {
  const isFormChanged = !this.areObjectsEqual(this.testCaseUpdateForm.value, this.initialFormValue);
  this.toggleSubmitButton(isFormChanged);
}

// Helper function to check if two objects are equal
areObjectsEqual(obj1: any, obj2: any): boolean {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}

toggleSubmitButton(isFormChanged: boolean): void {
  const submitButton = document.getElementById('submitBtn') as HTMLButtonElement;
  if (submitButton) {
    submitButton.disabled = !isFormChanged; // Disable if form is unchanged, enable if changed
  }
}
// hasChange: boolean = false;
// formHasChanged(): boolean {
//   return Object.entries(this.testCaseUpdateForm).some(
//     ([field, value]) => value !== this.newUserForm.value[field]
//   );
// }
onCreateGroupFormValueChange(){
  const initialValue = JSON.parse(JSON.stringify(this.testCaseUpdateForm.value))
  this.testCaseUpdateForm.valueChanges.subscribe(value => {
    this.hasChange = Object.keys(initialValue).some(key => this.testCaseUpdateForm.value[key] != 
                      initialValue[key])
                      // return this.hasChange;
                      console.log('hasChange',this.hasChange);                 
                      
  });
  
}
clearTag()
{
  this.testCaseUpdateForm.patchValue({
    dataLabels : null
  })
  this.dataLabelsForUpdate = undefined;
}

get f(){
  return this.testCaseUpdateForm.controls
}
onUpdateTestCase(){
this.submitted = true;
  if(this. testCaseUpdateForm.invalid){
    return;
  }

  if(this.testCaseUpdateForm.value.title.trim().length == 0)
  {
      this.toastrService.clear();
      this.toastrService.warning("Title field should not be empty");
      return;
  }

  var objFormval = this.testCaseUpdateForm.value;
  if (!/^[^:|*?<>/\\"]+$/.test(this.testCaseUpdateForm.value.title)) {
    this.toastrService.clear();
    this.toastrService.warning(
      'Case name is not Valid, Name can not contain /[<>:"/\\|?*'
    );
    return;
  }
  //console.log(objFormval); 
  // title: "TestCase5", id: "619f3d0168b4d67eb853bee0", testCaseId: "05", execuationIteration: "1",…}
  // active: "ENABLE"
const editValue={
  title:objFormval.title.trim(),
  id : this.Id,
  testCaseId : objFormval.testCaseId,
  execuationIteration:objFormval.executionIteration,
  dataLabels : objFormval.dataLabels,
  comment: objFormval.comment,
  active :"ENABLE",
}

if(this.ADOCheck)
{
  editValue['adoIntId'] = objFormval.adoIntId;
}

  this.http.post(this.url + '/HuLoopRest/huloop/' + 'test/editTestCaseTitle/' + this.projectId +'/'+ this.parentId  ,editValue). subscribe((data) => {
    if(data) {
      this.testCassedata= data;
      this.dialogRef.close(true);
      } 
   });
}

closeDialog() {
  this.dialogRef.close(false);
}

}